import { Dispatch, Action } from 'redux'
import { TagDropdownMainMapDispatchReturnType } from './types/TagDropdownMainMapDispatchReturnType'

export const TagDropdownMainMapDispatch = (
  _dispatch: Dispatch<Action>
): TagDropdownMainMapDispatchReturnType => {
  return {
  }
}
